import formComponent from '@/util/proto/formComponent'

//审批结果：1、已通过；2、已拒绝
const result = [
  {value:1 , label:'通过'},
  {value:2 , label:'拒绝'},
]

export default {
  extends: formComponent ,

  props:{
    id:{
      default:''
    },
  },
  data() {
    return {
      loading:0,
      state:{
        reason:null
      }
    }
  },
  created(){
    
  },
  methods:{
    save(params){
      this.$request.companyReview(params).then(resp => {
        this.loading = 0
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('审核完成')
          this.$emit('ok')
        }
      })  
    },
    pass(){
      this.loading = 1
      this.save({id:this.id , reason:this.state.reason , result:1})
    },
    reject(){
      if( !this.state.reason ){
        this.$Message.error('请填写拒绝理由')
      }else{
        this.loading = 2
        this.save({id:this.id , reason:this.state.reason , result:2})
      }
    }
  },
  render(){
    const { loading } = this
    return (
      <div>
        <div class="modal-body">
          <Input type="textarea" placeholder="审批理由" autosize={{ minRows: 2, maxRows: 6 }} v-model={this.state.reason} />
        </div>
        <div class="modal-footer">
          <Button style="margin-right:8px;" loading={loading == 2} on-click={this.reject} type="default">拒绝</Button>
          <Button loading={loading == 1} on-click={this.pass} type="primary">通过</Button>
        </div>
      </div>
    )
  }
}